<template>
    <div class="data" :class="{'dataDark':isDark}">
        <van-skeleton :row="50" :loading="logding">
            <template v-if="currentInfo">
                <div class="nav">
                    <span class="title">球队盘路</span>
                    <span class="details" @click="goRaceSchedule">查看详情<van-icon name="arrow" /></span>
                    <span class="tabs">
                        <em :class="{active: tabs == 1}" @click="clickInfo(1)">让分</em>
                        <em :class="{active: tabs == 2}" @click="clickInfo(2)">总分</em>
                    </span>
                </div>
                <div class="teamDetour">
                    <div class="histogram">
                        <div class="top">
                            <span :style="{height: `${currentInfo.winAvg}%`}" class="red">
                                <em>{{currentInfo.winAvg}}%</em>
                            </span>
                            <span :style="{height: `${currentInfo.tieAvg}%`}" class="blue">
                                <em>{{currentInfo.tieAvg}}%</em>
                            </span>
                            <span :style="{height: `${currentInfo.failAvg}%`}" class="green">
                                <em>{{currentInfo.failAvg}}%</em>
                            </span>
                        </div>
                        <div class="bottom">
                            <template v-if="tabs == 1">
                                <span>赢</span>
                                <span>走</span>
                                <span>输</span>
                            </template>
                            <template v-else>
                                <span>大</span>
                                <span>走</span>
                                <span>小</span>
                            </template>
                        </div>
                    </div>
                    <div class="statistics">
                        <div class="title">
                            场次
                        </div>
                        <template v-if="tabs == 1">
                            <div class="item">
                                <span>赢</span>
                                <span>{{currentInfo.win}}</span>
                            </div>
                            <div class="item">
                                <span>走</span>
                                <span>{{currentInfo.tie}}</span>
                            </div>
                            <div class="item">
                                <span>输</span>
                                <span>{{currentInfo.fail}}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="item">
                                <span>大</span>
                                <span>{{currentInfo.win}}</span>
                            </div>
                            <div class="item">
                                <span>走</span>
                                <span>{{currentInfo.tie}}</span>
                            </div>
                            <div class="item">
                                <span>小</span>
                                <span>{{currentInfo.fail}}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="nearly_10Fields">
                    <div class="text">近10场</div>
                    <p>
                        <em v-for="(item, index) in currentInfo.near" :key="index" :class="{red: item == '嬴' || item == '大', green:  item == '输' || item == '小'}">{{item}}</em>
                    </p>
                    <div class="tips">
                        （远）
                    </div>
                </div>
            </template>
            <template v-if="data">
                <div class="nav">
                    <span>球队数据</span>
                    <span class="picker" @click="show = true">
                        {{kind}}
                        <van-icon name="arrow-down" />
                    </span>
                </div>
                <div class="teamData">
                    <div class="table">
                        <div class="tbody">
                            <div class="left">
                                <div class="item header">
                                    <div class="competitionSeason">
                                        赛季
                                    </div>
                                    <div class="sessions">
                                        场次
                                    </div>
                                </div>
                                <div class="item" v-for="(item, index) in data[kind]" :key="index">
                                    <div class="competitionSeason">
                                        {{item.season}}
                                    </div>
                                    <div class="sessions">
                                        {{item.sch}}
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="item header">
                                    <div>胜负</div>
                                    <div>胜率</div>
                                    <div>得分</div>
                                    <div>篮板</div>
                                    <div>助攻</div>
                                    <div>抢断</div>
                                    <div>盖帽</div>
                                    <div>投篮</div>
                                    <div>投篮%</div>
                                    <div>三分</div>
                                    <div>三分%</div>
                                    <div>罚球</div>
                                    <div>罚球%</div>
                                    <div>犯规</div>
                                </div>
                                <div class="item" v-for="(item, index) in data[kind]" :key="index">
                                    <div>{{item.win == 0 ? 0 : item.win ? item.win : '-'}}/{{item.fail || '-'}}</div>
                                    <div>{{item.win_per == 0 ? 0 : item.win_per ? item.win_per : '-'}}%</div>
                                    <div>{{item.score == 0 ? 0 : item.score ? item.score : '-'}}</div>
                                    <div>{{item.backboard == 0 ? 0 : item.backboard ? item.backboard : '-'}}</div>
                                    <div>{{item.helpattack == 0 ? 0 : item.helpattack ? item.helpattack : '-'}}</div>
                                    <div>{{item.rob == 0 ? 0 : item.rob ? item.rob : '-'}}</div>
                                    <div>{{item.cover == 0 ? 0 : item.cover ? item.cover : '-'}}</div>
                                    <div>{{item.shoot == 0 ? 0 : item.shoot ? item.shoot : '-'}}</div>
                                    <div>{{item.shoot_hit_per == 0 ? 0 : item.shoot_hit_per ? item.shoot_hit_per : '-'}}%</div>
                                    <div>{{item.threemin == 0 ? 0 : item.threemin ? item.threemin : '-'}}</div>
                                    <div>{{item.threemin_hit_per == 0 ? 0 : item.threemin_hit_per ? item.threemin_hit_per : '-'}}%</div>
                                    <div>{{item.punishball == 0 ? 0 : item.punishball ? item.punishball : '-'}}</div>
                                    <div>{{item.punishball_hit_per == 0 ? 0 : item.punishball_hit_per ? item.punishball_hit_per : '-'}}%</div>
                                    <div>{{item.foul == 0 ? 0 : item.foul ? item.foul : '-'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </van-skeleton>

        <van-popup
            v-model="show"
            round
            position="bottom"
            :style="{ height: '40vh' }"
        >
            <van-picker
                show-toolbar
                :default-index="season_kind.indexOf(kind)"
                :columns="season_kind"
                @confirm="onConfirm"
                @cancel="show = false"
            />
        </van-popup>
        <!-- <Skeleton v-show="logding"/> -->
    </div>
</template>

<script>
import { getLQTeamData } from "@/api/team.js"
// import Skeleton from "@/components/common/skeleton"
export default {
    name: "data",
    components: {
        // Skeleton
    },
    data () {
        return {
            tabs: 1,
            show: false,
            columns: ['2001', '2002'],
            team_id: this.$route.query.team_id || 1,
            data: null,
            windingRoad: null,
            season_kind: '',
            kind: '',
            currentInfo: {},
            logding: true
        };
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    async created () {
        await this.getLQTeamData()
        await this.$nextTick()
        this.logding = false
        // window.scrollTo({
        //     top: 0,
        //     behavior: "instant"
        // })
    },
    methods: {
        goRaceSchedule () {
            this.$router.push({
                path: "/team/schedule",
                query: this.$route.query
            })
        },
        clickInfo (num) {
            this.tabs = num
            if (num === 1) {
                this.currentInfo = {
                    winAvg: this.windingRoad.let_win_per,
                    tieAvg: this.windingRoad.let_tie_per,
                    failAvg: this.windingRoad.let_fail_per,
                    near: this.windingRoad.near_let,
                    win: this.windingRoad.let_win,
                    tie: this.windingRoad.let_tie,
                    fail: this.windingRoad.let_fail
                }
            } else {
                this.currentInfo = {
                    winAvg: this.windingRoad.bs_big_per,
                    tieAvg: this.windingRoad.bs_tie_per,
                    failAvg: this.windingRoad.bs_small_per,
                    near: this.windingRoad.near_total,
                    win: this.windingRoad.bs_big,
                    tie: this.windingRoad.bs_tie,
                    fail: this.windingRoad.bs_small
                }
            }
        },
        async getLQTeamData () {
            const params = {
                team_id: this.team_id
            }
            const res = await getLQTeamData(params)
            if (res.errno === 0) {
                if (res.data) {
                    const obj = {}
                    res.data.data.forEach((item) => {
                        if (obj[item.season_kind]) {
                            obj[item.season_kind].push(item)
                        } else {
                            obj[item.season_kind] = [item]
                        }
                    });
                    this.data = obj
                    this.windingRoad = res.data.panlu
                    this.season_kind = Array.from(new Set(res.data.data.map(item => item.season_kind)))
                    this.kind = this.season_kind[this.season_kind.indexOf(res.data.season_kind)]
                    this.currentInfo = {
                        winAvg: this.windingRoad.let_win_per,
                        tieAvg: this.windingRoad.let_tie_per,
                        failAvg: this.windingRoad.let_fail_per,
                        near: this.windingRoad.near_let,
                        win: this.windingRoad.let_win,
                        tie: this.windingRoad.let_tie,
                        fail: this.windingRoad.let_fail
                    }
                }
            } else {
                this.$toast(res.errmsg)
            }
        },
        onConfirm (value) {
            this.kind = value
            this.show = false
        }
    }
}
</script>

<style lang="less" scoped>
.data{
    /deep/.van-skeleton{
        padding: 10px;
        height: 64vh;
        overflow: hidden;
    }
    .nav{
        padding: 0 14px;
        height: 43px;
        padding-top: 8px;
        font-size: 13px;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;
        &::before{
            content: '';
            width: 3px;
            height: 14px;
            background: #169AFF;
            margin-right: 5px;
        }
        position: relative;
        .picker{
            position: absolute;
            right: 14px;
        }
        .details{
            font-size: 11px;
            font-weight: 400;
            color: #169AFF;
            margin-left: 20px;
        }
        .tabs{
            position: absolute;
            right: 14px;
            border-radius: 4px;
            border: 1px solid #169AFF;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            em{
                flex: 1;
                font-size: 12px;
                font-weight: 400;
                color: #169AFF;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .active{
                background: #169AFF;
                color: #fff;
            }
        }
    }
    .teamDetour{
        display: flex;
        justify-content: space-between;
        // align-items: center;
        padding: 0 14px;
        .histogram{
            width: 160px;
            .top{
                display: flex;
                align-items: flex-end;
                height: 110px;
                padding-top: 20px;
                span{
                    width: 50px;
                    margin-right: 5px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    em{
                        position: absolute;
                        top: -20px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                    }
                    &:last-child{
                        margin: 0;
                    }
                }
                .red{
                    background: #FF5048;
                }
                .blue{
                    background: #169AFF;
                }
                .green{
                    background: #43A000;
                }
            }
            .bottom{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 5px;
                span{
                    flex: 1;
                    text-align: center;
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }
        .statistics{
            width: 130px;
            padding-top: 10px;
            .title {
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item{
                display: flex;
                align-items: center;
                margin-top: 16px;
                span{
                    flex: 1;
                    text-align: center;
                }
            }
        }
    }
    .nearly_10Fields{
        margin-top: 10px;
        display: flex;
        align-items: center;
        padding: 0 14px;
        .text{
            font-size: 12px;
            font-weight: 400;
            color: #333333
        }
        p{
            display: flex;
            align-items: center;
            em{
                width: 22px;
                height: 22px;
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-left: 5px;
            }
            .red{
                background: #FF5048;
            }
            .green{
                background: #43A000;
            }
        }
        .tips{
            font-size: 12px;
            font-weight: 400;
            color: #333333;
        }
    }
    .teamData{
        .table{
            .tbody{
                display: flex;
                .left{
                    width: 80px;
                    .item{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #f2f2f2;
                        height: 32px;
                        font-size: 11px;
                        font-weight: 400;
                        color: #333333;
                        div{
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-child(even) {
                            background: #F5F5F5;
                        }
                    }
                    .header{
                        background: #FFFFFF;
                        box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.1);
                        font-size: 11px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
                .right{
                    flex: 1;
                    float: left;
                    overflow: auto;
                    .item{
                        width: 560px;
                        white-space:nowrap;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        font-size: 11px;
                        font-weight: 400;
                        color: #333333;
                        div{
                            display: inline-block;
                            width: 40px;
                        }
                        &:nth-child(even) {
                            background: #F5F5F5;
                        }
                    }
                    .header{
                        background: #FFFFFF;
                        box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.1);
                        font-size: 11px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
        }
    }
}
.dataDark{
    background-color: #191919;
    min-height: calc(100vh - 200px);
    .nav{
        color: #d3d3d3;
        .tabs{
            em{
                background-color: #191919;
            }
        }
    }
    .teamDetour{
        .histogram{
            .top{
                span{
                    em{
                        color: #d3d3d3;
                    }
                }
            }
            .bottom{
                span{
                    color: #d3d3d3;
                }
            }
        }
        .statistics{
            .title{
                color: #d3d3d3;
            }
            .item{
                span{
                    color: #d3d3d3;
                }
            }
        }
    }
    .nearly_10Fields{
        .text{
            color: #d3d3d3
        }
        .tips{
            color: #d3d3d3;
        }
    }
    .teamData{
        .table{
            .tbody{
                .left{
                    .item{
                        border-color: #191919;
                        color: #d3d3d3;
                        &:nth-child(even) {
                            background: #2f2f2f;
                        }
                    }
                    .header{
                        background-color: #191919;
                        color: #a6a6a6;
                    }
                }
                .right{
                    .item{
                        color: #d3d3d3;
                        &:nth-child(even) {
                            background: #2f2f2f;
                        }
                    }
                    .header{
                        background: #191919;
                        color: #a6a6a6;
                    }
                }
            }
        }
    }
}
</style>
